// libs
import { styled } from '@nykaa/ui-components';

export const Container = styled.div`
  ${({ theme }) => theme.typography.bodySmall};
  display: flex;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing.spacing20};
`;

export const Currency = styled.span`
  margin-right: ${({ theme }) => theme.spacing.spacing10};
`;

export const AmountWrapper = styled.span`
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.bodyMedium}
`;
export const Amount = styled.span`
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.bodyMedium}
`;

export const OriginalPrice = styled(Amount)`
  text-decoration: line-through;
  color: ${({ theme }) => theme.colors.textDisabled};
  margin-left: ${({ theme }) => theme.spacing.spacing20};
  ${({ theme }) => theme.typography.bodySmall};
`;

export const Discount = styled.span`
  margin-left: ${({ theme }) => theme.spacing.spacing20};
  ${({ theme }) => theme.typography.bodySmall};
  color: ${({ theme }) => theme.colors.positivePrimary};
`;
